<template>
    <div>
        <headC myId=2></headC>
        <navigationC name="About Us"></navigationC>
        <div class="content-area">
            <div class="content-title">About Us</div>
            <div class="content-text">
                <span>
                    Oclean Chemical Co., Ltd. is a comprehensive enterprise integrating production and trade.
                </span>
            </div>
            <div class="content-text">
                <span>
                    The main products are disinfection water treatment chemicals, 
                    such as Trichloroisocyanuric acid (TCCA), Sodium Dichloro Iso Cyanurate (SDIC) and calcium hypochlorite.
                </span>
            </div>
            <div class="content-text">
                <span>
                    As a manufacturer, Oclean Chemical has invested and built its own factory in Shandong, 
                    China's largest raw material producing area, since 2004. At present, the company has its own R & D center 
                    and strict quality control system. The factory has 6 production lines, more than 400 workers, 
                    uses the latest equipment and technology, and produces 35,000 to 5,000 tons of water treatment and disinfection products per year.
                </span>        
            </div>
            <div class="content-text">
                <span>
                    The company has more than ten years of export experience, one-stop service such as supplier inspection, 
                    dangerous package and booking. It has won praise and trust from domestic and foreign customers for years 
                    with reliable product quality and excellent after-sales service. 
                </span>
            </div>
            <div class="content-text">
                <span>
                    Our company persists: “Quality First, Customer First” the concept of development all the time. 
                    Providing the high-quality products and high quality service for our customers.
                </span>
            </div>
            <div class="content-text">
                <span>
                    Clean world, Oclean Chemical! In order to create a clean world, we sincerely welcome your cooperation.
                </span>
            </div>
            <div class="about-us-image">
                <div v-for="item in usImages" :key="item.name" class="image-item">
                    <img :src=item.url class="product-img" >
                </div>
            </div>
            
        </div>
        <footC></footC>
    </div>

</template>
<script>
import headC from '../components/headC.vue'
import footC from '../components/footC.vue'
import navigationC from '../components/navigation.vue'
export default ({
    name: 'aboutUsV',
    components: {
        headC,
        footC,
        navigationC,
    },
    data() {
        return {
            shrink: false,
            fullWidth: 0,
            fixed: false,
            companyName: this.CONSTANT.companyName,
            usImages: this.CONSTANT.usImages,
        };
    },
    
    methods:{
      
    },
    mounted: function(){
        document.title= this.companyName + " | about";
    },
})
   
</script>
<style scoped>
.content-area{
    width: 90%;
    margin-left: 5%;
    margin-top: 10px;
    margin-bottom: 20px;
}
.content-title{
    font-size: 30px;
    padding: 10px;
    text-align: center;
}

.content-text{
    white-space: pre-wrap;
    text-indent: 10px;
    padding-top: 10px !important;
    max-width: 1200px;
    margin: 0 auto;
}

.about-us-image{
    max-width: 1200px;
    margin: 0 auto;
    margin-top: 40px !important;
}
.image-item{
    width: 30%;
    margin-right: 5%;
    float: left;
    margin-bottom: 40px;
    overflow: hidden;
}
.image-item:nth-child(3n){
    margin-right: 0;
}
.image-item img{
    cursor: pointer;
    transition: transform 0.3s ease;
}

.image-item img:hover{
    transform: scale(1.2);
}

.product-img{
    width: 100%;
    
}

</style>